import React from 'react';
import { connect } from 'react-redux';
import { func, string, arrayOf, shape } from 'prop-types';
import invariant from 'invariant';
import locationShape from 'propTypes/locationShape';
import Segment from 'components/Map/MapComponents/Segment';
import coord from 'propTypes/coord';
import { operations } from 'state/ducks/map';

const priorityWeights = {
  problem: 4,
  disconnected: 3,
  warning: 2,
  ok: 1,
};

function getPriorityForStatus(status) {
  const weight = priorityWeights[status];
  invariant(weight !== undefined, `No sort weight for status: ${status}`);
  return weight;
}

function addSegmentPriority(segment, hoveredId, selectedId) {
  if (segment.id === hoveredId) {
    return {
      ...segment,
      priority: 20,
    };
  }

  if (segment.id === selectedId) {
    return {
      ...segment,
      priority: 10,
    };
  }

  return {
    ...segment,
    priority: getPriorityForStatus(segment.status),
  };
}

export function SegmentGroup({
  segments,
  selectEntity,
  enterEntity,
  leaveEntity,
  routeParams,
  currentHover,
}) {
  // eslint-disable-next-line global-require
  const SortingFeatureGroup = require('components/Map/MapComponents/SortingFeatureGroup').default;
  const selectedId = routeParams.id;
  const hoveredId = currentHover && currentHover.id;

  const sortedSegmentsWithStateAndPriority = segments
    .map(segment => addSegmentPriority(segment, hoveredId, selectedId))
    .sort((segmentA, segmentB) => segmentA.priority - segmentB.priority);

  return (
    <SortingFeatureGroup>
      {sortedSegmentsWithStateAndPriority.map(segment => {
        const { id, priority } = segment;
        return (
          <Segment
            key={`segment-${id}`}
            priority={priority}
            segment={segment}
            isActive={id === selectedId || id === hoveredId}
            onSelect={() => {
              selectEntity({
                id,
                type: 'segment',
              });
            }}
            onEnter={() =>
              enterEntity({
                id,
                type: 'segment',
              })}
            onLeave={() =>
              leaveEntity({
                id,
                type: 'segment',
              })}
          />
        );
      })}
    </SortingFeatureGroup>
  );
}

SegmentGroup.propTypes = {
  segments: arrayOf(
    shape({
      id: string,
      path: arrayOf(coord),
      from: locationShape,
      to: locationShape,
    })
  ).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  routeParams: shape({
    id: string,
  }).isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

export default connect(mapStateToProps, operations)(SegmentGroup);



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/SegmentGroup/index.js